import type { ServiceRecord } from '../types';

import { PER_UNIT_PART_TYPES } from 'pages/MaintenancePage/components/LogServicePanel/helpers/getUnitCount';

// Mirrors the log form's isSerialShown against a saved record's shape: calibrations
// and general (part-less) inspections never carry a serial, and one serial cannot
// describe every unit, so a per-unit part (PER_UNIT_PART_TYPES) with no unitNumber
// (an all-units record) hides the field too. Single-unit and aggregate-counter
// parts keep it.
export const getIsSerialShown = ({ record }: { record: ServiceRecord }): boolean => {
    if (record.eventType === 'calibrated' || !record.partType) {
        return false;
    }

    return record.unitNumber !== undefined || !PER_UNIT_PART_TYPES.includes(record.partType);
};
